"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.aspendentalTypography = void 0;
var common = __importStar(require("../../shared/typography"));
exports.aspendentalTypography = [
    common.heroXL,
    common.heroLarge,
    common.heroMedium,
    common.header1,
    common.header2,
    common.header3,
    common.header4,
    common.bodyXLBook,
    common.bodyLargeBook,
    common.bodyLargeBold,
    common.bodyLargeSemiBold,
    common.bodyMediumBook,
    common.bodyMediumBold,
    common.bodyMediumSemiBold,
    common.bodySmallBook,
    common.bodySmallBold,
    common.bodySmallSemiBold,
    common.captionLarge,
    common.captionMedium,
    common.buttonLabel,
    common.buttonEnterprise,
    common.overline,
    common.lowestLevelBook,
    common.lowestLevelSemiBold,
    common.lowestLevelBold,
    common.assistiveText,
    common.errorValidation,
    common.notification,
    common.breadcrumbLarge,
    common.breadcrumbSmall,
    common.mainNavigationDefault,
    common.mainNavigationDefaultSubCategory,
    common.mainNavigationLight,
    common.accordionLarge,
    common.accordionSmall,
    common.badgeLabel,
    common.chipLabel,
    common.floatingLabel,
    common.textLinkSmall,
    common.textLinkMedium,
    common.textLinkLarge,
    common.tabLabelInactive,
    common.tabLabelActive,
];
